import { get, reduce, orderBy } from 'lodash-es';
import { fromJS } from 'immutable';

const getActions = () => [
  {
    route: '/surveys/',
    action: 'view',
    type: 'link',
    label: 'survey.grid.cell.action.btn.view.label',
  },
];

export const getSurvey = survey => ({
  id: String(survey.id),
  code: survey.code,
  iconName: survey.icon_name,
  name: survey.name,
  sequence: survey.sequence,
  actions: getActions(),
  calc: survey.calc,
  extraData: survey.extra_data,
  result: survey.result,
});

export const getSurveyList = surveys => {
  try {
    return surveys.map(survey => getSurvey(survey));
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
  }
  return [];
};

export const sortedResult = ({ result }) => {
  try {
    return orderBy(result, ['score'], ['desc']);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
  }
  return [];
};

export const transformResult = data => ({ ...data, result: sortedResult(data) });

export const getSurveyMap = surveys => {
  try {
    return reduce(
      getSurveyList(surveys),
      (acc, { id, code, iconName, name, sequence, actions, calc, extraData, result }) => ({
        ...acc,
        [id]: fromJS({ id, code, iconName, name, sequence, actions, calc, extraData, result }),
      }),
      {}
    );
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
  }
  return [];
};

const getQuestions = questions =>
  questions.map(({ code, digits, name, type, default: def, selection, ...rest }) => {
    const extra = {
      code,
      name,
      technical_kind: type,
      business_kind: 'questionnaire',
      ...rest,
    };

    if (def) extra.default = def;
    if (digits !== undefined) extra.digits = digits;
    if (selection) extra.selection = orderBy(selection, ['sequence']).map(({ name: n, value }) => [value, n]);

    return extra;
  });

const getCalc = (parts, id, sequence) => ({
  questionnaire: parts.map(({ questions, id: idPart, description, ...rest }) => ({
    extra: getQuestions(questions),
    id,
    idPart,
    description: description || '',
    ...rest,
    sequence,
  }))[0],
});

export const getSurveysListFromV2 = surveys =>
  surveys.map(({ id, code, icon, title: name, sequence, parts, ...rest }) => ({
    id,
    code,
    icon_name: icon,
    name,
    sequence,
    calc: getCalc(parts, id, sequence),
    ...rest,
  }));

export const getSubmitBodyFromV1 = ({ id, idPart, payload: { extra_data: extraData } }) => ({
  questionnaire: { id: parseInt(id, 10) },
  parts: [{ id: idPart, answers: { ...extraData } }],
});

export const getSubmitResponseFromV2 = ({ parts: [{ results = [] } = {}] = [] }, commercialProducts) => ({
  result: results.map(({ commercial_product: commercialProduct, description, eligible, score }) => {

    const comProd = commercialProducts.filter(commProd => commProd.code === commercialProduct)[0];

    return {
      commercialProduct: get(comProd, 'id', ''),
      message: description,
      isEligible: eligible,
      productName: get(comProd, 'rec_name', ''),
      score,
      iconName: '',
    };
  }),
});
